import React from 'react'
import { Tooltip } from 'antd'
import { ContentContainer, ScanChartWidget, ScanWidgetTitle, TrendCount } from 'components'
import { ScanSeverity } from 'components/Severity'
import { ScanScore } from 'components/Score'
import { colors } from 'style/theme'
import styled from '@emotion/styled'
import Moment from 'react-moment'
import ScanState from 'views/ScanSettings/Scans/components/ScanState'

export const verifyColor = (state) => {
  let color = colors.success.color

  switch (state.toLowerCase()) {
    case 'webhook':
    case 'scanning':
      color = colors.info.color
      break
    case 'complete with post error':
      color = colors.warning.color
      break
    case 'scan failed':
    case 'failed':
    case 'failed with post error':
      color = colors.error.color
      break
    default:
      color = colors.success.color
      break
  }
  return color
}

const durationFormating = (num) => {
  if (num < 1) return '1 Seconds'

  if (num > 1 && num < 60) return Math.round(num) + ' Seconds'

  if (num > 60) {
    num = num / 60
    if (num < 60) return Math.round(num) + ' Minutes'
    else return Math.round(num / 60) + ' Hours'
  }
}

export const limitStringLength = (str, maxLength) => {
  maxLength = maxLength || 40
  if (str.length > maxLength) {
    str = str.substr(0, maxLength)
    str = `${str}...`
  }
  return str
}

const Duration = styled.div(() => ({
  fontSize: '12px',
  fontWeight: 'bold'
}))

const Status = styled.div(() => ({
  fontSize: '15px',
  fontWeight: 'bold'
}))

const Score = styled.div(() => ({
  fontSize: '15px',
  fontWeight: 'bold'
}))

const DurationText = styled.span(() => ({
  color: 'gray'
}))

const EndDate = styled.div(() => ({
  fontSize: '12px',
  fontWeight: 'bold'
}))

const GridCont = styled.div((props) => ({
  display: 'grid',
  gridTemplateColumns: props.showLeftColumn ? '120px auto' : 'auto',
  minHeight: '110px'
}))

const LeftCont = styled.div(() => ({
  display: 'grid',
  gridTemplateRows: '10px 100px'
}))

const RightCont = styled.div((props) => ({
  display: 'grid',
  gridTemplateRows: props.url ? '50px 5px 30px 5px 20px' : '60px 10px 20px'
}))

const Upper = styled.div(() => ({
  display: 'grid',
  gridTemplateColumns: 'auto'
}))

const Bottom = styled.div((props) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  lineHeight: props.isDetailsView ? '1.5rem' : '3rem'
}))

const EndDateText = styled.span(() => ({
  color: 'gray'
}))

const SubTitle = styled.span(() => ({
  fontWeight: 500,
  fontSize: '12px'
}))

const Seperator = styled.hr(() => ({
  opacity: 0.3,
  clear: 'both'
}))

const StyledUrl = styled.a(() => ({
  fontSize: '0.8rem',
  color: '#00a1ff',
  fontWeight: 700,
  textDecoration: 'underline'
}))

const NoData = styled.div(() => ({
  backgroundColor: 'gray',
  width: '50px',
  height: '10px',
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: '33px'
}))

export default [
  {
    key: 'scan_a_score',
    render: (stats, data, isDetailsView) => {
      let score = stats && stats.score
      let duration = stats && stats.duration
      let endDate = stats && stats.complete_date
      let status = stats && (stats.state || stats.status)
      let completePages = stats && stats.documents_complete
      let totalPages = stats && stats.documents_total
      let url = stats && stats.url

      return (
        <ContentContainer>
          <GridCont showLeftColumn={status === 'Complete' || status === 'Stopped'}>
            {(status === 'Complete' || status === 'Stopped') && (
              <LeftCont>
                <div></div>
                <Score>
                  <ScanScore
                    style={{ float: 'left' }}
                    fontWeight="700"
                    labelSize="40px"
                    width={90}
                    score={score}
                    thickness={7}
                  />
                </Score>
              </LeftCont>
            )}
            <RightCont url={url}>
              <Upper>
                <Status>
                  <ScanState state={status} pageCount={totalPages} completedCount={completePages} />
                </Status>
              </Upper>

              {url && <Seperator />}

              {url && (
                <Tooltip title={url} placement="bottom">
                  <StyledUrl href={url} target="_blank">
                    {limitStringLength(url, 50)}
                  </StyledUrl>
                </Tooltip>
              )}

              <Seperator />

              <Bottom isDetailsView={isDetailsView}>
                <Duration>
                  <SubTitle>Duration: </SubTitle>
                  <DurationText>{durationFormating(duration)}</DurationText>
                </Duration>
                {endDate && (
                  <EndDate>
                    <SubTitle>Completed: </SubTitle>
                    <EndDateText>
                      <Moment utc local fromNow>
                        {endDate}
                      </Moment>
                    </EndDateText>
                  </EndDate>
                )}
              </Bottom>
            </RightCont>
          </GridCont>
        </ContentContainer>
      )
    }
  },
  {
    dataKey: 'severities',
    render: (severities, data) => {
      const isFailedScan = data && data.state == 'Failed'
      return (
        <ContentContainer>
          <ScanChartWidget>
            <ScanWidgetTitle>SEVERITY</ScanWidgetTitle>
            {!isFailedScan && <ScanSeverity data={severities} height="95%" />}
            {isFailedScan && <NoData />}
          </ScanChartWidget>
        </ContentContainer>
      )
    }
  },
  {
    dataKey: 'status',
    render: (status, data, isDetailsView) => {
      const documentErr =
        data &&
        (data.visible_document_errors !== undefined ? data.visible_document_errors : data['total_document_errors'])
      const selectorsErr =
        data &&
        (data.visible_selector_errors !== undefined ? data.visible_selector_errors : data['total_selector_errors'])
      const totalDocumentsErrAmount = data && data.total_document_errors
      const totalSelectorsErrAmount = data && data.total_selector_errors
      const isFailedScan = data && data.state == 'Failed'
      return (
        <>
          {!isFailedScan ? (
            <TrendCount
              title="DOCUMENT ERRORS"
              countValue={documentErr}
              markerColor={colors.error.color}
              totalErrors={totalDocumentsErrAmount}
            />
          ) : (
            <ContentContainer>
              <ScanChartWidget>
                <ScanWidgetTitle>DOCUMENT ERRORS</ScanWidgetTitle>
                <NoData />
              </ScanChartWidget>
            </ContentContainer>
          )}
          {!isFailedScan ? (
            <TrendCount
              title="SELECTOR ERRORS"
              countValue={selectorsErr}
              markerColor={colors.error.color}
              totalErrors={totalSelectorsErrAmount}
            />
          ) : (
            <ContentContainer>
              <ScanChartWidget>
                <ScanWidgetTitle>SELECTOR ERRORS</ScanWidgetTitle>
                <NoData />
              </ScanChartWidget>
            </ContentContainer>
          )}
        </>
      )
    }
  }
]
